import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import hasInterface from '../../../../../hasInterface';
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import ItemVisitor from '../../index/ItemVisitor';
import PointOnGeometryLocator from './PointOnGeometryLocator';
import LinearRing from '../../geom/LinearRing';
import SortedPackedIntervalRTree from '../../index/intervalrtree/SortedPackedIntervalRTree';
import LineSegment from '../../geom/LineSegment';
import Polygonal from '../../geom/Polygonal';
import ArrayList from '../../../../../java/util/ArrayList';
import LinearComponentExtracter from '../../geom/util/LinearComponentExtracter';
import ArrayListVisitor from '../../index/ArrayListVisitor';
import RayCrossingCounter from '../RayCrossingCounter';
var IndexedPointInAreaLocator = /*#__PURE__*/function () {
  function IndexedPointInAreaLocator() {
    _classCallCheck(this, IndexedPointInAreaLocator);
    IndexedPointInAreaLocator.constructor_.apply(this, arguments);
  }
  _createClass(IndexedPointInAreaLocator, [{
    key: "locate",
    value: function locate(p) {
      if (this._index === null) {
        this._index = new IntervalIndexedGeometry(this._geom);
        this._geom = null;
      }
      var rcc = new RayCrossingCounter(p);
      var visitor = new SegmentVisitor(rcc);
      this._index.query(p.y, p.y, visitor);
      return rcc.getLocation();
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [PointOnGeometryLocator];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geom = null;
      this._index = null;
      var g = arguments[0];
      if (!(hasInterface(g, Polygonal) || g instanceof LinearRing)) throw new IllegalArgumentException('Argument must be Polygonal or LinearRing');
      this._geom = g;
    }
  }]);
  return IndexedPointInAreaLocator;
}();
export { IndexedPointInAreaLocator as default };
var SegmentVisitor = /*#__PURE__*/function () {
  function SegmentVisitor() {
    _classCallCheck(this, SegmentVisitor);
    SegmentVisitor.constructor_.apply(this, arguments);
  }
  _createClass(SegmentVisitor, [{
    key: "visitItem",
    value: function visitItem(item) {
      var seg = item;
      this._counter.countSegment(seg.getCoordinate(0), seg.getCoordinate(1));
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [ItemVisitor];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._counter = null;
      var counter = arguments[0];
      this._counter = counter;
    }
  }]);
  return SegmentVisitor;
}();
var IntervalIndexedGeometry = /*#__PURE__*/function () {
  function IntervalIndexedGeometry() {
    _classCallCheck(this, IntervalIndexedGeometry);
    IntervalIndexedGeometry.constructor_.apply(this, arguments);
  }
  _createClass(IntervalIndexedGeometry, [{
    key: "init",
    value: function init(geom) {
      var lines = LinearComponentExtracter.getLines(geom);
      for (var i = lines.iterator(); i.hasNext();) {
        var line = i.next();
        var pts = line.getCoordinates();
        this.addLine(pts);
      }
    }
  }, {
    key: "addLine",
    value: function addLine(pts) {
      for (var i = 1; i < pts.length; i++) {
        var seg = new LineSegment(pts[i - 1], pts[i]);
        var min = Math.min(seg.p0.y, seg.p1.y);
        var max = Math.max(seg.p0.y, seg.p1.y);
        this._index.insert(min, max, seg);
      }
    }
  }, {
    key: "query",
    value: function query() {
      if (arguments.length === 2) {
        var min = arguments[0],
          max = arguments[1];
        if (this._isEmpty) return new ArrayList();
        var visitor = new ArrayListVisitor();
        this._index.query(min, max, visitor);
        return visitor.getItems();
      } else if (arguments.length === 3) {
        var _min = arguments[0],
          _max = arguments[1],
          _visitor = arguments[2];
        if (this._isEmpty) return null;
        this._index.query(_min, _max, _visitor);
      }
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._isEmpty = false;
      this._index = new SortedPackedIntervalRTree();
      var geom = arguments[0];
      if (geom.isEmpty()) this._isEmpty = true;else this.init(geom);
    }
  }]);
  return IntervalIndexedGeometry;
}();
IndexedPointInAreaLocator.SegmentVisitor = SegmentVisitor;
IndexedPointInAreaLocator.IntervalIndexedGeometry = IntervalIndexedGeometry;